import { useTranslation } from 'react-i18next'

import { SnoozeSettings } from '~/boundedContext/settings/components/snooze-settings'
import { LinkButton } from '~/components/link-button'
import { MobileBottomLayout } from '~/layout/mobile-bottom'

export const SnoozeSettingsPage = () => {
  const { t } = useTranslation()

  return (
    <MobileBottomLayout>
      <SnoozeSettings />
      <LinkButton to="/settings" variant="outline">
        {t('Back')}
      </LinkButton>
    </MobileBottomLayout>
  )
}
